exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wrapper[data-v-525a6ede] {\n  min-height: calc(100svh - 50px);\n}\n", ""]);

// exports
